<template>
  <div>
    <basic-container>
      <el-form ref="form" :model="projectDynamicForm">
        <!-- 工程项目名称选择 -->
        <el-form-item label="工程项目名称">
          <div style="display: flex; align-items: center;">
            <!-- 输入工程项目名称 -->
            <el-input v-model="projectDynamicForm.name" placeholder="请输入工程项目名称"
              style="flex: 1; min-width: 200px;"></el-input>
          </div>
        </el-form-item>

        <!-- 动态表单配置部分 -->
        <el-form-item label="工程服务阶段">
          <el-card>
            <div v-for="(stage, stageIndex) in projectStages" :key="stageIndex">
              <el-table :data="stage.forms" border style="width: 100%; margin-top: 20px">
                <!-- 服务阶段名称 -->
                <el-table-column prop="stageName" label="服务阶段名称" min-width="150">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.stageName" placeholder="请输入服务阶段名称"></el-input>
                  </template>
                </el-table-column>
                <!-- 服务阶段排序 -->
                <el-table-column prop="sort" label="排序" min-width="200">
                  <template v-slot="scope">
                    <el-input-number v-model="scope.row.sort" placeholder="请输入排序"></el-input-number>
                  </template>
                </el-table-column>
                <!-- 动态表单字段配置 -->
                <el-table-column label="表单配置" min-width="900">
                  <template v-slot="scope">
                    <el-table :data="scope.row.formFields" border style="width: 100%">
                      <el-table-column label="字段名称">
                        <template v-slot="innerScope">
                          <el-input v-model="innerScope.row.fieldName" placeholder="字段名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="控件类型">
                        <template v-slot="innerScope">
                          <el-select v-model="innerScope.row.inputType" placeholder="请选择控件类型">
                            <el-option v-for="type in inputTypes" :key="type.id" :label="type.name"
                              :value="type.id"></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column label="数据源">
                        <template v-slot="innerScope">
                          <el-select v-model="innerScope.row.dataSource" placeholder="请选择数据源">
                            <el-option v-for="source in dataSources" :key="source.id" :label="source.valueName"
                              :value="source.id"></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column label="是否为空">
                        <template v-slot="innerScope">
                          <el-radio-group v-model="innerScope.row.isNull">
                            <el-radio label="YES">是</el-radio>
                            <el-radio label="NO">否</el-radio>
                          </el-radio-group>
                        </template>
                      </el-table-column>
                      <el-table-column label="上传示例图片" align="center">
                        <template v-slot="innerScope">
                          <ImageUpload action="#" :multiple="true" :inTable="true" :limit="1"
                            @uploaded="(urls) => handleUploaded(urls, stageIndex, innerScope.$index)"
                            :uploaded-images="innerScope.row.picUrl" />
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="操作" width="200">
                        <template v-slot="innerScope">
                          <el-button type="text" size="small"
                            @click="removeField(stageIndex, innerScope.$index)">删除字段</el-button>
                          <el-button type="text" size="small" @click="addField(stageIndex)">增加字段</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <!-- 删除阶段 -->
                <el-table-column align="center" label="操作" width="150">
                  <template v-slot="scope">
                    <el-button type="text" size="small" @click="removeStage(stageIndex)">删除阶段</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item align="center">
              <el-button type="text" icon="el-icon-plus" size="small" @click="addStage">增加阶段</el-button>
            </el-form-item>
          </el-card>
        </el-form-item>
        <!-- 提交按钮 -->
        <el-form-item align="center">
          <el-button type="success" icon="el-icon-plus" @click="submit">新增工程项目产品</el-button>
        </el-form-item>
      </el-form>
    </basic-container>
  </div>
</template>

<script>
// import { findEngineeringProjectAll, findEngineeringDynamicId, findDataSourceAll, findDataSourceFields, addDynamic } from "@/api/work/projectDynamic";
import { findDataSourceAll, findDataSourceFields, addDynamic } from "@/api/work/engineeringProject/projectDynamic";

import ImageUpload from "@/components/imageUpload/ImageUpload";

export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      projectItems: [],
      projectDynamicForm: { projectItem: '' },
      projectStages: [],  // 动态服务阶段
      inputTypes: [],     // 输入控件类型
      dataSources: [],    // 数据源
    };
  },
  created() {
    // 获取输入控件类型
    findDataSourceFields().then(res => {
      this.inputTypes = JSON.parse(res.data);
    });

    // 获取数据源
    findDataSourceAll().then(res => {
      this.dataSources = JSON.parse(res.data).rows;
    });
  },
  methods: {
    // 更新图片成功
    handleUploaded(urls, stageIndex, fieldIndex) {
      if (this.projectStages[stageIndex] && this.projectStages[stageIndex].forms[0].formFields[fieldIndex]) {
        this.projectStages[stageIndex].forms[0].formFields[fieldIndex].picUrl = urls;
      }
    },
    // 增加一个阶段
    addStage() {
      this.projectStages.push({
        id: '',
        forms: [{
          stageName: '',
          sort: '',
          formFields: [{
            fieldName: '',
            inputType: '',
            dataSource: '',
            isNull: 'NO',
            picUrl: [],
          }]
        }]
      });
    },
    // 删除一个阶段
    removeStage(stageIndex) {
      this.projectStages.splice(stageIndex, 1);
    },
    // 增加一个字段
    addField(stageIndex) {
      this.projectStages[stageIndex].forms[0].formFields.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: 'NO',
        picUrl: [],
      });
    },
    // 删除一个字段
    removeField(stageIndex, fieldIndex) {
      this.projectStages[stageIndex].forms[0].formFields.splice(fieldIndex, 1);
    },
    // 提交配置
    submit() {
      let params = {
        name: this.projectDynamicForm.name,
        type: 'ENGINEERING',
        list: this.projectStages.map(stage => ({
          name: stage.forms[0].stageName,
          sort: stage.forms[0].sort,
          type: 'ENGINEERING',
          dynamicFormRequest: {
            fields: stage.forms[0].formFields.map(field => ({
              fieldName: field.fieldName,
              inputType: field.inputType,
              dataSource: field.dataSource,
              isNull: field.isNull,
              picUrl: field.picUrl.map(url => (typeof url === 'string' ? url : url.url)).join(','),
            }))
          }
        }))
      };
      // 提交数据
      addDynamic(params).then(res => {
        if (res.code == '200') {
          let item = {
            close: true,
            label: "新增",
            value: "/work/manageProject/add"
          };
          this.$message.success('提交成功');
          this.$store.commit("DEL_TAG", item);
          this.$router.go(-1);
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style>
/* 可根据需求增加样式 */
</style>
